import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.333 7.333h-.666a.667.667 0 1 0 0 1.334h.666a.667.667 0 1 0 0-1.334m0 2.667h-.666a.666.666 0 1 0 0 1.333h.666a.667.667 0 1 0 0-1.333m-4-4h4a.667.667 0 1 0 0-1.333h-4a.667.667 0 1 0 0 1.333M14 2H4.667A.667.667 0 0 0 4 2.667v2H2a.667.667 0 0 0-.667.666V12a2 2 0 0 0 2 2H12a2.667 2.667 0 0 0 2.667-2.667V2.667A.666.666 0 0 0 14 2M4 12a.667.667 0 1 1-1.333 0V6H4zm9.333-.667A1.333 1.333 0 0 1 12 12.667H5.213a2 2 0 0 0 .12-.667V3.333h8zm-6-2.666H8a.667.667 0 1 0 0-1.334h-.667a.667.667 0 1 0 0 1.334m0 2.666H8A.667.667 0 1 0 8 10h-.667a.666.666 0 1 0 0 1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })